import PropTypes from 'prop-types';

// @todo refactor naar ReactSVG
const DownwardsArrowComponent = ({ classNames }) => (
  <svg className={classNames} xmlns="http://www.w3.org/2000/svg" version="1.1" width="16" height="16">
    <path d="m 13,6 -5,5 -5,-5 z" />
  </svg>
);

DownwardsArrowComponent.propTypes = {
  classNames: PropTypes.string,
};

DownwardsArrowComponent.defaultProps = {
  classNames: '',
};

export default DownwardsArrowComponent;

